<!--/*
 * Copyright (c) 2020 The Awareness Company. All rights reserved. 
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */ -->
<template>
  <div>
    <div class="body-2 mt-3"></div>

    <v-card class="mx-auto" max-width="500" min-width="100%" style="margin-top:20px" flat>
      <v-card-title
        class="title font-weight-regular justify-space-between"
        v-if="step <= 12 && step != 0"
      >
        <span>{{ }}</span>
        <!-- <v-avatar
          v-if="step <= 12 && step != 0"
          color="purple lighten-2"
          class="subheading white--text"
          size="24"
          v-text="step"
        ></v-avatar> -->
        <div v-if="step <= 12 && step != 0" class="caption">
          {{step + '/12'}}
        </div>
      </v-card-title>

      <v-window v-model="step">
        <v-window-item :value="0">
          <v-card-text>
            <div class="body-1 mt-3">
              <p>Every day, thousands of South Africans use this COVID-19 Awareness dashboard to get insights on how the pandemic is affecting our country. We need your help; we want to give you valuable insights on how COVID-19 is affecting our country and our people.</p>

              <p>This survey is aimed at people currently residing in South Africa who are 18 years or older only and is governed by all regulations as determined by the Republic of South Africa.</p>
            </div>
            <span
              v-if="surveyLastSubmitDate"
              style="color: blueviolet;"
            >Thank you for your submission on {{surveyLastSubmitDate}}. Please feel free to submit an update.</span>
          </v-card-text>
        </v-window-item>

        <v-window-item :value="1">
          <v-card-text>
            <span class="body-1 mt-3">Your age?</span>
            <v-text-field v-model="age" type="number" :rules="rules.age"></v-text-field>
          </v-card-text>
        </v-window-item>

        <v-window-item :value="2">
          <v-card-text>
            <span class="body-1 mt-3">Your gender?</span>
            <v-select
              v-model="select_gender"
              :items="gender"
              item-text="state"
              item-value="abbr"
              return-object
            ></v-select>
          </v-card-text>
        </v-window-item>

        <v-window-item :value="3">
          <v-card-text>
            <span class="body-1 mt-3">The area you are located in?</span>
            <v-card-text>
              <v-autocomplete
                v-model="model"
                :items="items"
                :loading="isLoading"
                :search-input.sync="search"
                hide-no-data
                item-text="MP_NAME"
                item-value="MP_NAME"
                placeholder="Start typing to search"
                prepend-icon="search"
                return-object
              ></v-autocomplete>
            </v-card-text>

            <v-expand-transition>
              <v-card-text v-if="model" class="grey lighten-3">
                <div v-for="(field, i) in fields" :key="i">
                  <v-list-item-content v-if="field.key == 'MP_NAME'">
                    <v-list-item-subtitle class="caption">AREA</v-list-item-subtitle>
                    <v-list-item-title v-text="field.value"></v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-content v-if="field.key == 'PROVNAME'">
                    <v-list-item-subtitle class="caption">PROVINCE</v-list-item-subtitle>
                    <v-list-item-title v-text="field.value"></v-list-item-title>                    
                  </v-list-item-content>
                </div>
                <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn v-if="model" :disabled="!model" @click="clearModel">
                Clear
                <!-- <v-icon right>mdi-close-circle</v-icon> -->
              </v-btn>
            </v-card-actions>
              </v-card-text>
            </v-expand-transition>
            
          </v-card-text>
        </v-window-item>

        <v-window-item :value="4">
          <v-card-text>
            <span
              class="body-1 mt-3"
            >The total number of people residing in your household during the lockdown?</span>
            <v-text-field v-model="peopleAmount" type="number" :rules="rules.number"></v-text-field>
          </v-card-text>
        </v-window-item>

        <v-window-item :value="5">
          <v-card-text>
            <span
              class="body-1 mt-3"
            >Do you have any underlying health conditions? e.g. heart disease, high blood pressure, diabetes, kidney disease, compromised immune system, tuberculosis, chronic respiratory disease etc.</span>
            <v-select
              v-model="select_health"
              :items="health"
              item-text="state"
              item-value="abbr"
              return-object
            ></v-select>
          </v-card-text>
        </v-window-item>

        <v-window-item :value="6">
          <v-card-text>
            <span
              class="body-1 mt-3"
            >Which of the following best describes the financial impact the lockdown will have on you?</span>
            <v-radio-group v-model="select_financial" column>
              <v-radio label="I can meet my financial obligations without assistance" value="A"></v-radio>
              <v-radio
                style="margin-top:10px"
                label="I can meet my financial obligations but I had to ask for assistance (either from people I know or my creditors)"
                value="B"
              ></v-radio>
              <v-radio
                style="margin-top:10px"
                label="I can’t meet my financial obligations"
                value="C"
              ></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-window-item>

        <v-window-item :value="7">
          <v-card-text>
            <span
              class="body-1 mt-3"
            >What effect do you think the coronavirus will have on our local economy?</span>
            <v-radio-group v-model="select_economy" column>
              <v-radio label="No impact" value="A"></v-radio>
              <v-radio style="margin-top:10px" label="Somewhat of an impact" value="B"></v-radio>
              <v-radio style="margin-top:10px" label="An extremely high impact" value="C"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-window-item>

        <v-window-item :value="8">
          <v-card-text>
            <span
              class="body-1 mt-3"
            >How often do you think you will need to leave your home during the current lockdown?</span>
            <v-select
              v-model="select_travel"
              :items="travel"
              item-text="state"
              item-value="abbr"
              return-object
            ></v-select>
          </v-card-text>
        </v-window-item>

        <v-window-item :value="9">
          <v-card-text>
            <span
              class="body-1 mt-3"
              style="margin-bottom:8px;"
            >If you need to leave your home during the lockdown, what would be the main reasons, besides for emergencies?</span>
            <v-checkbox
              style="margin-top:16px"
              v-model="select_travelreason"
              label="For my job, as it is part of essential services"
              value="A"
            ></v-checkbox>
            <v-checkbox
              style="margin-top:0px;"
              v-model="select_travelreason"
              label="For my job, even though it is not part of essential services"
              value="B"
            ></v-checkbox>
            <v-checkbox
              style="margin-top:0px"
              v-model="select_travelreason"
              label="For medical  supplies"
              value="C"
            ></v-checkbox>
            <v-checkbox
              style="margin-top:0px"
              v-model="select_travelreason"
              label="To buy groceries"
              value="D"
            ></v-checkbox>
            <v-checkbox
              style="margin-top:0px"
              v-model="select_travelreason"
              label="To deliver groceries or medical supplies to a relative"
              value="E"
            ></v-checkbox>
            <v-checkbox
              style="margin-top:0px"
              v-model="select_travelreason"
              label="To walk my pet"
              value="F"
            ></v-checkbox>
            <v-checkbox
              style="margin-top:0px"
              v-model="select_travelreason"
              label="For exercise"
              value="G"
            ></v-checkbox>
            <v-checkbox
              style="margin-top:0px"
              v-model="select_travelreason"
              label="To visit my family"
              value="H"
            ></v-checkbox>
            <v-checkbox style="margin-top:0px" v-model="select_travelreason1" label="Other"></v-checkbox>
            <v-textarea
              v-if="select_travelreason1"
              v-model="otherreasons"
              color="teal"
              :rules="rules.othertext"
              counter
              maxlength="128"
              rows="2"
            >
              <template v-slot:label>
                <div>
                  Please provide your other reasons:
                  <small>(optional)</small>
                </div>
              </template>
            </v-textarea>
          </v-card-text>
        </v-window-item>

        <v-window-item :value="10">
          <v-card-text>
            <span class="body-1 mt-3">Do you think it is necessary to have a lockdown?</span>
            <v-select
              v-model="select_necessary"
              :items="necessary"
              item-text="state"
              item-value="abbr"
              return-object
            ></v-select>
          </v-card-text>
        </v-window-item>

        <v-window-item :value="11">
          <v-card-text>
            <span
              class="body-1 mt-3"
              style="margin-bottom:8px;"
            >Why do you think it is necessary to have a lockdown?</span>
            <v-checkbox
              style="margin-top:16px"
              v-model="select_lockdown"
              label="It will limit the spread of the disease"
              value="A"
            ></v-checkbox>
            <v-checkbox
              style="margin-top:0px;"
              v-model="select_lockdown"
              label="It will flatten the curve of new cases which will help healthcare providers give better services"
              value="B"
            ></v-checkbox>
            <v-checkbox
              style="margin-top:0px"
              v-model="select_lockdown"
              label="So that my family and I don’t get infected"
              value="C"
            ></v-checkbox>
          </v-card-text>
        </v-window-item>

        <v-window-item :value="12">
          <v-card-text>
            <span
              class="body-1 mt-3"
            >How do you feel about the effects that COVID-19 is having in South Africa at the moment?</span>
            <v-radio-group v-model="select_effect" column>
              <v-radio label="I am very worried for myself and other people" value="A"></v-radio>
              <v-radio style="margin-top:10px" label="I am very worried for myself" value="B"></v-radio>
              <v-radio
                style="margin-top:10px"
                label="I am very worried for other people but I feel safe myself"
                value="C"
              ></v-radio>
              <v-radio
                style="margin-top:10px"
                label="I am not too worried and feel it is under control"
                value="D"
              ></v-radio>
              <v-radio style="margin-top:10px" label="I am not worried at all" value="E"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-window-item>
        <v-window-item :value="13">
          <v-card-text style="height: 100px;">
            <span class="body-1 mt-3" style="color:blueviolet;" v-text="lastpage"></span>
          </v-card-text>
        </v-window-item>
      </v-window>

      <v-card-actions>
        <v-btn :disabled="step === 0 || step === 13" text @click="step--">Back</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-if="step <= 11 && step != 0"
          color="purple darken-1"
          dark
          depressed
          @click="step++"
        >Next</v-btn>

        <v-btn
          v-if="step === 12"
          type="submit"
          color="purple darken-1"
          dark
          depressed
          @click="processForm"
        >Submit</v-btn>
        <v-btn
          v-if="step === 13"
          type="submit"
          color="purple darken-1"
          dark
          depressed
          @click="resetFrom"
        >Restart Survey</v-btn>

        <v-btn v-if="step === 0" color="purple darken-1" dark depressed @click="step++">Start Survey</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Survey",
  props: ["surveyGuid", "surveyLastSubmitDate", "haveSubmittedSurvey"],
  data: () => ({
    step: 0,
    age: null,
    select_gender: { state: null, abbr: null },
    gender: [
      { state: "Male", abbr: "A" },
      { state: "Female", abbr: "B" },
      { state: "Rather not say", abbr: "C" }
    ],
    peopleAmount: null,
    select_health: { state: null, abbr: null },
    health: [
      { state: "Yes", abbr: "A" },
      { state: "No", abbr: "B" },
      { state: "Rather not say", abbr: "C" }
    ],
    select_financial: null,
    select_economy: null,
    travel: [
      { state: "Never", abbr: "A" },
      { state: "1 - 3 times", abbr: "B" },
      { state: "4 - 10 times", abbr: "C" },
      { state: "More than 10 times", abbr: "D" }
    ],
    select_travel: { state: null, abbr: null },
    otherreasons: "",
    select_travelreason: [],
    select_travelreason1: false,

    select_necessary: { state: null, abbr: null },
    necessary: [
      { state: "Yes", abbr: "A" },
      { state: "No", abbr: "B" }
    ],
    select_lockdown: [],
    select_effect: null,

    select_location: null,
    select_province: null,
    descriptionLimit: 60,
    entries: [],
    isLoading: false,
    model: null,
    search: null,
    cookieGuid: null,
    lastpage: "Busy processing your submission...",
    rules: {
      age: [
        val =>
          val > 17 ||
          `Invalid age, please make sure you filled in your age correctly. Only persons over the age of 18 are permitted to submit this survey.`
      ],
      number: [
        val =>
          val > 0 ||
          `Invalid number, please make sure you filled the number in correctly.`
      ],
      othertext: [v => v.length <= 128 || "Max 182 characters"]
    },
    othershow: false
  }),
  created: function() {
    this.cookieGuid = this.surveyGuid;
  },
  computed: {
    currentTitle() {
      switch (this.step) {
        case 1:
          return "Sign-up";
        case 2:
          return "Create a password";
        default:
          return "Account created";
      }
    },
    fields() {
      if (!this.model) return [];

      return Object.keys(this.model).map(key => {
        var entry = this.model[key];
        if (key == "MP_NAME") {
          this.select_location = entry;
        }
        if (key == "PROVNAME") {
          this.select_province = entry;
        }
        return {
          key,
          value: this.model[key] || "n/a"
        };
      });
    },
    items() {
      return this.entries.map(entry => {
        const Description =
          entry.MP_NAME.length > this.descriptionLimit
            ? entry.MP_NAME.slice(0, this.descriptionLimit) + "..."
            : entry.MP_NAME;
        return Object.assign({}, entry, { Description });
      });
    }
  },
  watch: {
    search(val) {
      // Items have already been loaded
      if (this.items.length > 0) return;

      // Items have already been requested
      if (this.isLoading) return;

      this.isLoading = true;
      // Lazily load input items
      fetch("data/geo/Sub.json")
        .then(res => res.json())
        .then(res => {
          const { count, entries } = res;
          this.count = count;
          this.entries = entries;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    }
  },
  methods: {
    clearModel: function() {
      this.model = null;
      this.select_location = null;
      this.select_province = null;
    },
    selectOther: function() {
      if (this.othershow == false) {
        this.othershow = true;
      } else {
        this.othershow = false;
      }
    },
    resetFrom: function() {
      (this.step = 0),
        (this.entries = []),
        (this.model = null),
        (this.search = null),
        (this.age = null),
        (this.select_gender = { state: null, abbr: null }),
        (this.select_province = null),
        (this.select_location = null),
        (this.peopleAmount = null),
        (this.select_health = { state: null, abbr: null }),
        (this.select_financial = null),
        (this.select_economy = null),
        (this.select_travel = { state: null, abbr: null }),
        (this.select_travelreason1 = false),
        (this.otherreasons = ""),
        (this.select_travelreason = []),
        (this.select_necessary = { state: null, abbr: null }),
        (this.select_lockdown = []),
        (this.select_effect = null),
        (this.othershow = false),
        (this.lastpage = "Busy processing your submission...");
    },

    processForm: function() {
      this.cookieGuid = this.surveyGuid;

      var self = this;
      //console.log("self", this.select_gender.abbr);

      if (
        this.age == null &&
        this.select_gender.abbr == null &&
        this.select_province == null &&
        this.select_location == null &&
        this.peopleAmount == null &&
        this.select_health.abbr == null &&
        this.select_financial == null &&
        this.select_economy == null &&
        this.select_travel.abbr == null &&
        this.select_travelreason.length == 0 &&
        this.select_travelreason1 == false &&
        this.select_necessary.abbr == null &&
        this.select_lockdown.length == 0 &&
        this.select_effect == null
      ) {
        alert("Please fill in the survey to submit or close to cancel.");

        this.step = 1;
      } else if (this.age != null && this.age < 18) {
        alert(
          "Invalid age is filled in. Please correct your age before you submit"
        );
        this.step = 1;
      } else if (this.peopleAmount != null && this.peopleAmount < 1) {
        alert(
          "Invalid number filled in for the total number of people residing in your household during the lockdown. Please correct the number before you submit"
        );
        this.step = 4;
      } else {
        if (this.select_travelreason1 == true) {
          this.select_travelreason.push("I");
        } else {
          this.otherreasons = "";
        }

        this.step++;

        axios
          .post(
            "https://hydra-health.azurewebsites.net/api/CoronaPoll?code=NY0MlAfRQMiphouZ8JajMErtBqdYCjqqKb3hRKDVMayV1e6qAbHc5w==",
            {
              Q1: this.age,
              Q2: this.select_gender.abbr,
              Q3a: this.select_province,
              Q3b: this.select_location,
              Q4: this.peopleAmount,
              Q5: this.select_health.abbr,
              Q6: this.select_financial,
              Q7: this.select_economy,
              Q8: this.select_travel.abbr,
              Q9: this.select_travelreason,
              Q9i: this.otherreasons,
              Q10: this.select_necessary.abbr,
              Q11: this.select_lockdown,
              Q12: this.select_effect,
              BrowserId: this.cookieGuid
            }
          )
          .then(function(response) {
            //console.log("success", response);

            var ID = response.data.browserId;
            //console.log("id", ID);

            var surveyData = { guid: ID };
            self.lastpage = "Thank you for your submission.";
            self.$emit("message_survey", surveyData);

            //post the GA
            gtag('event', 'survey', {
              'event_category' : 'submit',
              'send_to': 'UA-161523063-1'
            });
          })
          .catch(error => {});
      }
    }
  }
};
</script>

